export const languageSetterList = {
  newAccess: {
    en: "New access",
    ua: "Новий запит",
    ru: "Новый запрос",
  },

  companyName: {
    en: "Company",
    ua: "Компанія",
    ru: "Компания",
  },

  domain: {
    en: "Domain",
    ua: "Домен",
    ru: "Домен",
  },

  type: {
    en: "Type",
    ua: "Тип",
    ru: "Тип",
  },

  limitByUsers: {
    en: "License count limit",
    ua: "Ліміт активних ліцензій",
    ru: "Лимит активных лицензий",
  },

  limitByDays: {
    en: "Expires In (days)",
    ua: "Ліміт по часу",
    ru: "Лимит по времени",
  },

  userCount: {
    en: "User count",
    ua: "Користувачів",
    ru: "Пользователей",
  },

  actions: {
    en: "Actions",
    ua: "Опції",
    ru: "Действия",
  },

  userName: {
    en: "User name",
    ua: "Користувач",
    ru: "Пользователь",
  },

  email: {
    en: "E-mail",
    ua: "E-mail",
    ru: "E-mail",
  },

  privilege: {
    en: "Privilege",
    ua: "Доступ",
    ru: "Доступ",
  },

  ws: {
    en: "WS",
    ua: "WS",
    ru: "WS",
  },

  activation: {
    en: "Activation",
    ua: "Активація",
    ru: "Активация",
  },

  status: {
    en: "Status",
    ua: "Статус",
    ru: "Статус",
  },

  expireTo: {
    en: "Expire at",
    ua: "Активна до",
    ru: "Активна до",
  },

  appVersion: {
    en: "App version",
    ua: "Версія",
    ru: "Версия",
  },

  create: {
    en: "create",
    ua: "створити",
    ru: "создать",
  },

  cancel: {
    en: "cancel",
    ua: "скасувати",
    ru: "отменить",
  },

  name: {
    en: "User Name",
    ua: "Ім'я",
    ru: "Имя",
  },

  surname: {
    en: "User Surname",
    ua: "Прізвище",
    ru: "Фамилия",
  },

  fileInput: {
    en: "Click here or Drop the file",
    ua: "Натисніть чи перетягніть файл",
    ru: "Нажмите или перетащите файл",
  },

  createNewAccess: {
    en: "Create new access",
    ua: "Новий доступ",
    ru: "Новый доступ",
  },

  manual: {
    en: "Manual",
    ua: "Вручну",
    ru: "Вручную",
  },

  auto: {
    en: "Auto",
    ua: "Автоматично",
    ru: "Автоматически",
  },

  dropHere: {
    en: "Drop file here",
    ua: "Перетягніть файл сюди",
    ru: "Перетащите файл сюда",
  },

  fileCheckError: {
    en: 'Only ".data" files are allowed.',
    ua: 'Додайте файл з розширенням ".data"',
    ru: 'Добавьте файл с расширением ".data"',
  },

  fileReady: {
    en: "File is ready to be sent once the server endpoint is connected.",
    ua: "Файл готовий до надсилання після підключення сервера.",
    ru: "Файл готов к отправке после подключения сервера.",
  },

  expand: {
    en: "Expand",
    ua: "Розгорнути",
    ru: "Развернуть",
  },

  collapse: {
    en: "Collapse",
    ua: "Згорнути",
    ru: "Свернуть",
  },

  saveChanges: {
    en: "Save",
    ua: "Зберегти",
    ru: "Сохранить",
  },

  cancelChanges: {
    en: "Cancel",
    ua: "Скасувати",
    ru: "Отменить",
  },

  deleteButton: {
    en: "Delete",
    ua: "Видалити",
    ru: "Удалить",
  },

  unavailable: {
    en: "Unavailable",
    ua: "Недоступно",
    ru: "Недоступно",
  },

  companyUnit: {
    en: "company",
    ua: "компанію",
    ru: "компанию",
  },

  userUnit: {
    en: "user",
    ua: "користувача",
    ru: "пользователя",
  },

  deleteCompanyTitle: {
    en: "and all it's users'll be permanently deleted",
    ua: "та всіх її користувачів буде остаточно видалено",
    ru: "и все её пользователи будут окончательно удалены",
  },

  deleteUserTitle: {
    en: "will be permanently deleted",
    ua: "буде остаточно видалено",
    ru: "будет окончательно удален",
  },

  timeLeft: {
    en: "left",
    ua: "залишилось",
    ru: "осталось",
  },

  lessThanHour: {
    en: "Will end in less than an hour",
    ua: "Сплине менш, ніж за годину",
    ru: "Закончится менее чем через час",
  },

  expireTomorrow: {
    en: "Activation expires tomorrow!",
    ua: "Завтра активація закінчується!",
    ru: "Завтра активация истекает!",
  },

  activationExpired: {
    en: "Activation expired!",
    ua: "Срок активації завершено",
    ru: "Срок активации истек!",
  },

  userPass: {
    en: "Password",
    ua: "Пароль",
    ru: "Пароль",
  },

  authorizationTitle: {
    en: "Authorization",
    ua: "Авторизація",
    ru: "Авторизация",
  },

  authorizationButton: {
    en: "Log in",
    ua: "Увійти",
    ru: "Войти",
  },

  authorizationError401: {
    en: "Wrong user name or password!",
    ua: "Некоректне ім'я користувача чи пароль",
    ru: "Неверное имя пользователя или пароль!",
  },

  process: {
    en: "Wait please...",
    ua: "Очікуйте...",
    ru: "Ожидайте...",
  },

  infoLoadError: {
    en: "Info loading error",
    ua: "Помилка завантаження даних",
    ru: "Ошибка загрузки данных",
  },

  activeUsersCountTitle: {
    en: "Users count / Active users",
    ua: "Всього користувачів / Активних",
    ru: "Всего пользователей / Активных",
  },

  lastActivity: {
    en: "Last activity at:",
    ua: "Остання активність:",
    ru: "Последняя активность:",
  },
};

export const CompanyTableHeaderTitles = [
  { title: "", width: "4%" },
  { title: "domain", width: "16%" },
  { title: "type", width: "16%" },
  { title: "limitByUsers", width: "16%" },
  { title: "limitByDays", width: "16%" },
  { title: "userCount", width: "16%" },
  { title: "actions", width: "16%" },
];

export const UserTableHeaderTitles = [
  { title: "companyName", width: "8%" },
  { title: "userName", width: "12%" },
  { title: "email", width: "14%" },
  { title: "appVersion", width: "8%" },
  { title: "privilege", width: "10%" },
  { title: "ws", width: "4%" },
  { title: "activation", width: "10%" },
  { title: "status", width: "6%" },
  { title: "expireTo", width: "14%" },
  { title: "actions", width: "14%" },
];

const localizedOptions = {
  "1 month": { en: "1 month", ua: "1 місяць", ru: "1 месяц" },
  "2 months": { en: "2 months", ua: "2 місяці", ru: "2 месяца" },
  "3 months": { en: "3 months", ua: "3 місяці", ru: "3 месяца" },
  "6 months": { en: "6 months", ua: "6 місяців", ru: "6 месяцев" },
  "1 year": { en: "1 year", ua: "1 рік", ru: "1 год" },
  "2 years": { en: "2 years", ua: "2 роки", ru: "2 года" },
  "3 years": { en: "3 years", ua: "3 роки", ru: "3 года" },
  // "No limit": { en: "No limit", ua: "Без обмежень", ru: "Без ограничений" },

  manual: { en: "Manual", ua: "Вручну", ru: "Вручную" },
  auto: { en: "Auto", ua: "Автоматично", ru: "Автоматически" },

  requested: { en: "New request", ua: "Новий запит", ru: "Новый запрос" },
  active: { en: "Active", ua: "Активний", ru: "Активный" },
  revoked: { en: "Revoked", ua: "Відкликано", ru: "Отозвано" },

  accept: { en: "Accept", ua: "Прийняти", ru: "Принять" },
  sent: { en: "Sent", ua: "Надіслано", ru: "Отправлено" },
  updated: { en: "Updated...", ua: "Оновлюється...", ru: "Обновляется..." },

  revoke: { en: "Revoke", ua: "Відкликати", ru: "Отозвать" },
  restore: { en: "Restore ", ua: "Поновити", ru: "Возобновить" },
  error: { en: "Error", ua: "Помилка", ru: "Ошибка" },
};

const getLocalizedOption = (value, language) => localizedOptions[value]?.[language] ?? value;

export const getLimitLabel = getLocalizedOption;
export const getPrivilegeLabel = getLocalizedOption;
export const getActivationTypeLabel = getLocalizedOption;
export const getActivationStatusLabel = getLocalizedOption;
